var map = {
	"./audio-placeholder": 690,
	"./audio-placeholder.png": 690,
	"./avatar-missing": 472,
	"./avatar-missing.png": 472,
	"./avatar-missing.svg": 1077,
	"./halloween/clouds": 691,
	"./halloween/clouds.png": 691,
	"./halloween/halloween-emblem": 704,
	"./halloween/halloween-emblem.svg": 704,
	"./halloween/spider": 705,
	"./halloween/spider.svg": 705,
	"./halloween/spiderweb": 706,
	"./halloween/spiderweb.svg": 706,
	"./halloween/starfield": 707,
	"./halloween/starfield.png": 707,
	"./halloween/twinkle": 708,
	"./halloween/twinkle.svg": 708,
	"./header-missing": 638,
	"./header-missing.png": 638,
	"./reticle": 709,
	"./reticle.png": 709,
	"./soapbox-logo": 639,
	"./soapbox-logo-white": 640,
	"./soapbox-logo-white.svg": 640,
	"./soapbox-logo.svg": 639,
	"./sprite-post-functions": 710,
	"./sprite-post-functions.png": 710,
	"./video-placeholder": 711,
	"./video-placeholder.png": 711,
	"./void": 712,
	"./void.png": 712,
	"./web-push/web-push-icon_expand": 755,
	"./web-push/web-push-icon_expand.png": 755,
	"./web-push/web-push-icon_favourite": 756,
	"./web-push/web-push-icon_favourite.png": 756,
	"./web-push/web-push-icon_reblog": 757,
	"./web-push/web-push-icon_reblog.png": 757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1076;